import React, {createContext, useContext, useReducer} from 'react';

export const InitialState = {
  cup: {
    count: 1,
  },
  modal: {
    show: false,
    target: null,
    type: null,
  },
  timer: {
    action: null,
    play: false,
  },
  trigger: {
    show: false,
    type: null,
  },
};

export const StateContext = createContext();

export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

export const useStateValue = () => useContext(StateContext);
